import React from 'react';
import { styled, makeStyles, Paper, withStyles, Tabs, Tab } from '@material-ui/core';
import { CustomerLTV } from './CustomerLTV';
import { HeaderCustomerNote } from './HeaderCustomerNote';
import { CustomerModel } from '@/models/customer';

const TabHeader = withStyles({
	indicator: {
		backgroundColor: 'rgb(140, 127, 78)',
	},
})(Tabs);

const useStyles = makeStyles(() => ({
	mainWrapper: {
		width: '100%',
		padding: '40px 50px 20px 50px',
		marginBottom: '20px',
	},
	leftColumn: {
		float: 'left',
		maxWidth: '580px',
	},
	rightColumn: {
		float: 'right',
	},
	customerName: {
		marginBottom: '10px',
	},
	classificationNote: {
		marginTop: '10px',
	},
	tabHeader: {
		marginTop: '20px',
	},
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(() => ({
	textTransform: 'none',
}))

interface Props {
	customer: CustomerModel
	tabIndex: number
	onTabIndexChanged: (tagIndex: number) => void
}

export const Header = (props: Props) => {
	const classes = useStyles();
	const customer = props.customer;

	return (
		<Paper className={classes.mainWrapper}>
			<div className={classes.leftColumn}>
				<h1 className={classes.customerName}>{`${customer.firstName} ${customer.lastName}`}</h1>
				{customer.customerNotes && <HeaderCustomerNote customerTags={customer.customerTags} customerNotes={customer.customerNotes} />}
			</div>
			<div className={classes.rightColumn}>
				<div data-id="customerLTV">
					<CustomerLTV
						totalNights={customer.totalNights}
						totalReservations={customer.totalReservations}
						totalRevenue={customer.totalRevenue} />
				</div>
			</div>

			<div style={{ clear: 'both' }}></div>

			<TabHeader className={classes.tabHeader} value={props.tabIndex} name="containerTabs" onChange={(_event, tabIndex) => props.onTabIndexChanged(tabIndex)}>
				<StyledTab label="Profile" />
				<StyledTab label="All notes" />
			</TabHeader>
		</Paper>
	);
};
